import { useTranslation } from "react-i18next";

import { IconTicket02 } from "@pentabd/icons";
import { Header } from "@pentabd/ui";

import { ROUTES } from "@constants/routes";

const {
  TICKETS: {},
} = ROUTES;

export const AssignedTicketsHeader = () => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconTicket02 fill="dark" size="20" />,
    },
    {
      label: t("TICKETS.TICKET_LIST.ASSIGNED_TICKETS.BREADCRUMBS.FIRST_STEP"),
    },
  ];

  const headerText = {
    header: t("TICKETS.TICKET_LIST.ASSIGNED_TICKETS.HEADING"),
    subHeader: t("TICKETS.TICKET_LIST.ASSIGNED_TICKETS.DESCRIPTION"),
  };

  return (
    <Header
      headerText={headerText}
      breadcrumbs={breadcrumbs}
      // actions={[
      //   <Link to={`${MY_TICKETS}/${CREATE}`}>
      //     <Button fill="fill" type="primary" size="sm">
      //       <IconPlus fill="light" size="20" />
      //       {t("TICKETS.TICKET_LIST.ADD_NEW_BUTTON")}
      //     </Button>
      //   </Link>,
      // ]}
    />
  );
};
